<template>
  <div class="chart transmitter-usage-chart p-4 bg-gray-300">
    <label for="by_day_checkbox">Show Readings by Day</label>
    <input type="checkbox" v-model="by_day" id="by_day_checkbox" @change="updateChart">
    <div ref="chartContainer"></div>
    <div class="flex">
    <div class="flex-grow">
      <div class="flex justify-content-center">
        <datepicker @selected="setFromDate" :value="earliest_reading" wrapper-class="" input-class="border-gray-300 placeholder-gray-500 appearance-none rounded-none relative block w-full px-3 py-2 border text-gray-900 rounded-t-md focus:outline-none focus:shadow-outline-blue focus:border-blue-300 focus:z-10 sm:text-sm sm:leading-5" placeholder="Start Date" :disabled-dates="disabledDates"></datepicker>
        <label class="mx-2 mt-2">to</label>
        <datepicker @selected="setToDate" :value="latest_reading" wrapper-class="" input-class="border-gray-300 placeholder-gray-500 appearance-none rounded-none relative block w-full px-3 py-2 border text-gray-900 rounded-t-md focus:outline-none focus:shadow-outline-blue focus:border-blue-300 focus:z-10 sm:text-sm sm:leading-5" placeholder="End Date" :disabled-dates="disabledDates"></datepicker>
        <a class="m-2 border-gray-300 border px-1" @click="updateChart" :disabled="!this.enable_load"><i class="fas fa-arrow-right"></i></a>
      </div>
    </div>
  </div>
    <div class="flex justify-end mt-2">
      <a v-if="show_table" @click="show_table = !show_table" class="whitespace-no-wrap inline-flex items-center justify-center px-4 py-2 border border-transparent text-base leading-6 font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-500 focus:outline-none focus:border-indigo-700 focus:shadow-outline-indigo active:bg-indigo-700 transition ease-in-out duration-150 hover:no-underline">Hide Data</a>
      <a v-if="!show_table" @click="show_table = !show_table"  class="whitespace-no-wrap inline-flex items-center justify-center px-4 py-2 border border-transparent text-base leading-6 font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-500 focus:outline-none focus:border-indigo-700 focus:shadow-outline-indigo active:bg-indigo-700 transition ease-in-out duration-150 hover:no-underline">Show Raw Data</a>
      <a @click="exportTransmissions" class="whitespace-no-wrap inline-flex items-center justify-center px-4 py-2 border border-transparent text-base leading-6 font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-500 focus:outline-none focus:border-indigo-700 focus:shadow-outline-indigo active:bg-indigo-700 transition ease-in-out duration-150 hover:no-underline">Export Data</a>
    </div>
    <div class="data-table mt-4" v-show="show_table">
      <h4>Raw Data</h4>
      <table ref="table">
      </table>
    </div>
  </div>
</template>
<script>
let $ = require("jquery");
require("datatables.net");
require("datatables.net-dt");
require('@chartisan/chartjs');
import moment from 'moment';
import Datepicker from 'vuejs-datepicker';
export default {
  name: "TransmitterUsageChart",
  components: {
    Datepicker
  },
  props: {
    url: {
      type: String,
      required: true,
    },
    base_url: {
      type: String,
      required: true,
    },
    export_base_url: {
      type: String,
      required: true,
    },
    height: {
      type: String,
      default: "300px",
    },
    initial_from_date: {
      type: String,
    },
    earliest_reading: {
      type: String,
    },
    latest_reading: {
      type: String,
    },
    meter_type: {
      type: String,
    },
    meter_number: {
      type: String,
    }
  },
  data(){
    return {
      chart: {},
      datatable: {},
      show_table: false,
      from_date: null,
      to_date: null,
      by_day: true,
      enable_load: true,
      initial_from_date: null,
      oldest_possible: moment(this.earliest_reading),
      newest_possible: moment(this.latest_reading),
      disabledDates: {
        customPredictor: this.isDisabled
      }
    }
  },
  methods: {
    isDisabled(date){
      return date.getTime() < this.oldest_possible.valueOf() ||  date.getTime() > this.newest_possible.valueOf();
    },
    setFromDate(date){
      if(date !== null){
        this.from_date = moment(date);
        if(this.to_date !== null){
          this.enable_load = true;
        }
      }
    },
    setToDate(date){
      if(date !== null){
        this.to_date = moment(date);
        if(this.from_date !== null){
          this.enable_load = true;
        }
      }
    },
    updateChart(){
      if(this.to_date !== null && this.from_date !== null){
        let new_url = this.base_url + "&from_date=" + moment(this.from_date).unix() + "&to_date=" + moment(this.to_date).unix() + "&by_day=" + this.by_day;
        this.chart.update({
          url: new_url,
        });
      }
    },
    exportTransmissions(){
      if(this.to_date !== null && this.from_date !== null){
        let from_date= moment(this.from_date).unix();
        let to_date = moment(this.to_date).unix();
        let export_url = this.export_base_url + "/export/transmissions/from/" + from_date + "/to/" + to_date;
        const link = document.createElement('a');
        link.href = export_url;
        document.body.appendChild(link);
        link.click();
        link.remove();
      }
    },
    refreshTable(server_data){
      console.log("Refreshing table data!");
      console.log(server_data);
      this.datatable.clear();
      this.datatable.rows.add(server_data.data);
      this.datatable.draw();
    }
  },
  mounted() {
    this.oldest_possible = moment(this.earliest_reading);
    this.newest_possible = moment(this.latest_reading);
    this.from_date = Date.parse(this.start_reading);
    this.to_date = Date.parse(this.latest_reading);
    this.$refs.chartContainer.style.height = this.height;
    this.chart = new Chartisan({
      el: this.$refs.chartContainer,
      url: this.url,
      hooks: new ChartisanHooks()
          .responsive()
          .beginAtZero()
          .colors()
          .legend(false)
          .title({text: this.meter_type + ' Usage (' + this.meter_number + ')'})
          .custom(({data, merge, server}) => {
            this.refreshTable(server.chart.extra);
            return data;
          })
    });
    this.datatable = $(this.$refs.table).DataTable({
      responsive: true,
      columns: [
        { data: 'meter', title: 'Meter' },
        { data: 'from_date', title: 'From Date'},
        { data: 'to_date', title: 'To Date'},
        { data: 'old_reading', title: 'Previous Reading'},
        { data: 'new_reading', title: 'Current Reading' },
        { data: 'usage', title: 'Usage' }
      ],
      columnDefs: [
        {type: "date", targets: 1},
        {type: "date", targets: 2}
      ]
    });
  }
}
</script>

<style scoped>

</style>
